import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { DisplayMarkup } from '../../components/display-markup';
import { EventRegistrationData } from '../../types';

export function RegisterTermsAccept(props: {
  data: EventRegistrationData;
  accepted: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <Stack spacing={1} sx={{ pb: 1 }}>
      <Typography variant="h6" component="div">
        Terms and Conditions
      </Typography>

      <Box
        sx={{
          p: 1,
          height: 300,
          border: '1px solid #00000011',
          borderRadius: 1,
          overflow: 'auto',
        }}
      >
        <DisplayMarkup markup={props.data.TermsAndConditions} />
      </Box>

      <Box
        sx={{
          py: 2,
          textAlign: 'center',
          border: '1px solid',
          borderColor: props.accepted ? '#0000' : '#f005',
          borderRadius: 1,
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={props.accepted}
              onChange={(event, checked) => props.onChange(checked)}
            />
          }
          label="I agree to the terms and conditions"
          slotProps={{
            typography: {
              fontSize: 14,
            },
          }}
        />
      </Box>
    </Stack>
  );
}
